import { MicrosoftAuthConfig } from '@msal';

export const environment = {
  name: 'stage',
  production: true,
  remoteApi: 'https://app-casino-event-admin-api-stage.azurewebsites.net/api',

  microsoft: {
    clientId: 'ce1ad62c-a6b2-448b-9a90-60ab632b3799',
    authority: 'https://login.microsoftonline.com/6a7ef1e2-9e9e-412e-9824-b8c2856ce8f4',
    redirectUri: 'https://msadminapp-stage.bslog.com/',
    protectedResources: [
      {
        url: 'https://graph.microsoft.com/v1.0/me',
        scopes: ['user.read'],
      },
      {
        url: 'https://msadminapp-stage.bslog.com/',
        scopes: ['api://ce1ad62c-a6b2-448b-9a90-60ab632b3799/user_impersonation'],
      },
      {
        url: 'https://app-casino-event-admin-api-stage.azurewebsites.net/',
        scopes: ['api://ce1ad62c-a6b2-448b-9a90-60ab632b3799/user_impersonation'],
      },
    ],
    protectedResourcesDefaultScope: ['api://ce1ad62c-a6b2-448b-9a90-60ab632b3799/user_impersonation'],
  } satisfies MicrosoftAuthConfig,
};
